import { useState } from "react";
import RegimeType from "../../models/regime-type";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

interface RegimeTypeCardProps {
  regimeType: RegimeType;
}

export function RegimeTypeCard({ regimeType }: RegimeTypeCardProps) {
  const [open, setOpen] = useState(true);

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{regimeType.code}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{""}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Código:</strong> {regimeType.code}
          </p>
          <p>
            <strong>Descripción:</strong> {regimeType.description}
          </p>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
